module.exports = {"210214001":"丰荣街道","210214002":"铁西街道","210214003":"太平街道","210214004":"南山街道","210214005":"皮口街道","210214006":"城子坦街道","210214007":"大刘家街道","210214008":"杨树房街道","210214009":"大谭街道","210214010":"唐家房街道","210214011":"莲山街道","210214012":"安波街道","210214013":"沙包街道","210214014":"星台街道","210214015":"墨盘街道","210214016":"同益街道","210214017":"乐甲街道","210214018":"双塔街道","210214019":"四平街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210214.json
// module id = 520
// module chunks = 0